
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/orders/create",
      function () {
        return require("private-next-pages/orders/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/orders/create"])
      });
    }
  